import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { inject } from '@angular/core';
import { Firestore, collectionData, collection } from '@angular/fire/firestore';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  // imports: [AsyncPipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  imports: [],
})
export class HomeComponent {}
